import { render, staticRenderFns } from "./cmpconsultarfornecedores.vue?vue&type=template&id=054bed8e&"
import script from "./cmpconsultarfornecedores.vue?vue&type=script&lang=js&"
export * from "./cmpconsultarfornecedores.vue?vue&type=script&lang=js&"
import style0 from "./cmpconsultarfornecedores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports